<template>
  <div class="live_login">
    <form>
      <div class="live_login_pass">
        <h2 class="live_login_title">欢迎登录全景俱乐部</h2>
        <div class="live_login_input">
          <p>
            <label for="user" style="cursor:pointer"><i class="iconfont icon-geren"></i></label>
            <input type="text" id="user" name="user" v-model="user" placeholder="请输入您的账号" @input="user=user.replace(/[^\w]/g,'')">
          </p>
          <p>
            <label for="pass" style="cursor:pointer"><i class="iconfont icon-mima"></i></label>
            <input type="password" id="pass" name="pass" v-model="pass" autocomplete placeholder="请输入您的密码">
          </p>
          <p class="yz">
            <a-input class="yz_l" placeholder="请输入验证码" v-model:value="verify"/>
            <span class="yz_r">
              <img :src="urlcodeimg" alt="loading">
              <span @click="imgVerification">
                <i>看不清？</i>
              </span>
            </span>
          </p>
          <div class="live_login_join" @click="userLogin">
            <a-button type="primary" style="width:100%">登录</a-button>
          </div>
          <div class="live_login_changeclick">
            <span></span>
            <span @click="handlerforgetpass">忘记密码</span>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import {getImageCode,isPhoneExist,logins} from '@/api/api'
import {methodCallback} from '@/api/methodCallback'
import {notification} from 'ant-design-vue';
export default {
  data() {
    return {
      user: "", // 用户名
      pass: "", // 密码
      verify: '', // 验证码
      codeid: '', //验证码uid
      urlcodeimg: '',
    }
  },
  mounted() {
    this.user = ""
    this.pass = ""
    this.verify = ""
    this.imgVerification();
  },
  methods: {
    //图片验证码
    imgVerification(){
    	let data = {
    		width: 80,
    		height: 30,
    		codeType: 2
    	}
    	getImageCode(data)
    		.then((res) => {
          if(res.data.code == "SUCCESS"){
            this.urlcodeimg = res.data.data.code
            this.codeid = res.data.data.uid
          }else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //用户登录
    userLogin(){
    	if(this.user == ""){
    		notification.warning({
    			message: '警告！',
    			description: "用户名不能为空",
    			key: "10",
    			duration: 2,
    			top: '20px',
    		});
    		return
    	}else if(this.pass == ""){
    		notification.warning({
    			message: '警告！',
    			description: "密码不能为空",
    			duration: 2,
    			key: "11",
    			top: '20px',
    		});
    		return
    	}else if(this.verify == ""){
    	  notification.warning({
    	    message: '警告！',
    	    description: "验证码不能为空",
    	    duration: 2,
    	    key: "12",
    	    top: '20px',
    	  });
    	  return
    	}else{
        this.judgeUser()
      }
    },
    //判断用户是否存
    judgeUser(){
    	let data = {
    		phone: this.user
    	}
    	isPhoneExist(data)
    		.then((res) => {
          if(res.data.code === "NOT_FOUND_DATA"){
            notification.warning({
              message: '警告！',
              description: "用户名未注册,请先注册",
              duration: 2,
              key: "13",
              top: '20px',
            });
          }else if(res.data.code === "PHONE_EXIST"){
    				this.go()
    			}else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //登录接口
    go() {
    	let data = {
    		username: this.user,
        password: this.pass,
        imageUid: this.codeid,
        imageCode: this.verify
    	}
    	logins(data)
    		.then((res) => {
    			if(res.data.code === "SUCCESS"){
    	      localStorage.setItem("token", res.data.data.token)
    	      this.$router.replace("/mainpage")
          }else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //忘记密码
    handlerforgetpass() {
      this.$router.replace({
        path: "/forgetpass"
      })
    },

  }
}
</script>
<style scoped lang="less">
/* 登录样式 */
.live_login {
  height: 100%;
  background-attachment: fixed;
  background-size: cover;
  background: url("../../assets/images/002.png");
  &_pass {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -250px;
    margin-top: -260px;
    border: 1px solid black;
    width: 500px;
    height: 520px;
    background: #FFFFFF;
		border-radius: 4px;
    box-sizing: border-box;
    padding: 86px 70px 0 70px;
  }
  &_title {
    margin-bottom: 76px;
    width: 100%;
    height: 36px;
    font-size: 34px;
		line-height: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1877f2;
    text-align: center;
  }
  &_changeclick {
    display: flex;
    justify-content: space-between;
    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #434343;
      cursor: pointer;
    }
  }
  &_input {
    p {
      margin-bottom: 20px;
      width: 358px;
      height: 34px;
      border-radius: 2px;
      border: 1px solid #7b7b7b;
      display: flex;
      align-items: center;
      i {
        font-size: 24px;
        margin: 6px 10px;
        color: #1877f2;
      }
      input {
        border: none;
        width: 100%;
      }
    }
		.yz{
			border:none;
			display:flex;
			justify-content:space-between;
			&_l{
				width:150px;
				border:1px solid #7B7B7B;
			}
			&_r{
				border:1px solid black;
				display:inline-block;
				width:170px;
				height:32px;
				border-radius:4px;
				display: flex;
				align-items: center;
				img{
					width:80px;height:30px;margin-left:5px;
				}
				span{
					cursor:pointer;
					user-select:none;
					margin:0;
					margin-left:12px;
          i{
            font-size:12px;
            font-style:italic;
            margin:0;
          }
				}
			}
		}
  }
}

.live_login_join {
  height: 36px;
  margin-bottom: 25px;
}
</style>
